/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { BrokerViewModel } from './BrokerViewModel';
import {
    BrokerViewModelFromJSON,
    BrokerViewModelFromJSONTyped,
    BrokerViewModelToJSON,
} from './BrokerViewModel';
import type { CommissionSplitViewModel } from './CommissionSplitViewModel';
import {
    CommissionSplitViewModelFromJSON,
    CommissionSplitViewModelFromJSONTyped,
    CommissionSplitViewModelToJSON,
} from './CommissionSplitViewModel';
import type { ConsultantViewModel2 } from './ConsultantViewModel2';
import {
    ConsultantViewModel2FromJSON,
    ConsultantViewModel2FromJSONTyped,
    ConsultantViewModel2ToJSON,
} from './ConsultantViewModel2';
import type { ContactInfoViewModel } from './ContactInfoViewModel';
import {
    ContactInfoViewModelFromJSON,
    ContactInfoViewModelFromJSONTyped,
    ContactInfoViewModelToJSON,
} from './ContactInfoViewModel';
import type { IAPCONTACTFORINFO } from './IAPCONTACTFORINFO';
import {
    IAPCONTACTFORINFOFromJSON,
    IAPCONTACTFORINFOFromJSONTyped,
    IAPCONTACTFORINFOToJSON,
} from './IAPCONTACTFORINFO';
import type { IAPPRODUCTCODE } from './IAPPRODUCTCODE';
import {
    IAPPRODUCTCODEFromJSON,
    IAPPRODUCTCODEFromJSONTyped,
    IAPPRODUCTCODEToJSON,
} from './IAPPRODUCTCODE';
import type { IntermediaryViewModel } from './IntermediaryViewModel';
import {
    IntermediaryViewModelFromJSON,
    IntermediaryViewModelFromJSONTyped,
    IntermediaryViewModelToJSON,
} from './IntermediaryViewModel';

/**
 * 
 * @export
 * @interface AppointAnIntermediaryViewModel
 */
export interface AppointAnIntermediaryViewModel {
    /**
     * 
     * @type {IntermediaryViewModel}
     * @memberof AppointAnIntermediaryViewModel
     */
    intermediary: IntermediaryViewModel;
    /**
     * 
     * @type {BrokerViewModel}
     * @memberof AppointAnIntermediaryViewModel
     */
    broker?: BrokerViewModel;
    /**
     * 
     * @type {ConsultantViewModel2}
     * @memberof AppointAnIntermediaryViewModel
     */
    consultant?: ConsultantViewModel2;
    /**
     * 
     * @type {Array<CommissionSplitViewModel>}
     * @memberof AppointAnIntermediaryViewModel
     */
    commissionSplits?: Array<CommissionSplitViewModel>;
    /**
     * 
     * @type {boolean}
     * @memberof AppointAnIntermediaryViewModel
     */
    isIntermediaryDeclarationAccepted?: boolean;
    /**
     * 
     * @type {IAPCONTACTFORINFO}
     * @memberof AppointAnIntermediaryViewModel
     */
    contactForInfoTypeId?: IAPCONTACTFORINFO;
    /**
     * 
     * @type {ContactInfoViewModel}
     * @memberof AppointAnIntermediaryViewModel
     */
    contactInfo?: ContactInfoViewModel;
    /**
     * 
     * @type {IAPPRODUCTCODE}
     * @memberof AppointAnIntermediaryViewModel
     */
    productCode?: IAPPRODUCTCODE;
    /**
     * 
     * @type {boolean}
     * @memberof AppointAnIntermediaryViewModel
     */
    isComplete: boolean;
}

/**
 * Check if a given object implements the AppointAnIntermediaryViewModel interface.
 */
export function instanceOfAppointAnIntermediaryViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "intermediary" in value;
    isInstance = isInstance && "isComplete" in value;

    return isInstance;
}

export function AppointAnIntermediaryViewModelFromJSON(json: any): AppointAnIntermediaryViewModel {
    return AppointAnIntermediaryViewModelFromJSONTyped(json, false);
}

export function AppointAnIntermediaryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointAnIntermediaryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'intermediary': IntermediaryViewModelFromJSON(json['Intermediary']),
        'broker': !exists(json, 'Broker') ? undefined : BrokerViewModelFromJSON(json['Broker']),
        'consultant': !exists(json, 'Consultant') ? undefined : ConsultantViewModel2FromJSON(json['Consultant']),
        'commissionSplits': !exists(json, 'CommissionSplits') ? undefined : ((json['CommissionSplits'] as Array<any>).map(CommissionSplitViewModelFromJSON)),
        'isIntermediaryDeclarationAccepted': !exists(json, 'IsIntermediaryDeclarationAccepted') ? undefined : json['IsIntermediaryDeclarationAccepted'],
        'contactForInfoTypeId': !exists(json, 'ContactForInfoTypeId') ? undefined : IAPCONTACTFORINFOFromJSON(json['ContactForInfoTypeId']),
        'contactInfo': !exists(json, 'ContactInfo') ? undefined : ContactInfoViewModelFromJSON(json['ContactInfo']),
        'productCode': !exists(json, 'ProductCode') ? undefined : IAPPRODUCTCODEFromJSON(json['ProductCode']),
        'isComplete': json['IsComplete'],
    };
}

export function AppointAnIntermediaryViewModelToJSON(value?: AppointAnIntermediaryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Intermediary': IntermediaryViewModelToJSON(value.intermediary),
        'Broker': BrokerViewModelToJSON(value.broker),
        'Consultant': ConsultantViewModel2ToJSON(value.consultant),
        'CommissionSplits': value.commissionSplits === undefined ? undefined : ((value.commissionSplits as Array<any>).map(CommissionSplitViewModelToJSON)),
        'IsIntermediaryDeclarationAccepted': value.isIntermediaryDeclarationAccepted,
        'ContactForInfoTypeId': IAPCONTACTFORINFOToJSON(value.contactForInfoTypeId),
        'ContactInfo': ContactInfoViewModelToJSON(value.contactInfo),
        'ProductCode': IAPPRODUCTCODEToJSON(value.productCode),
        'IsComplete': value.isComplete,
    };
}

